<!DOCTYPE html>
<html lang="es">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Tasas</title>
    <style>
        body {
            margin: 0;
            padding: 0;
            font-family: Arial, sans-serif;
            overflow: hidden;
            /* Evita que se desborde el body */
        }

        .card {
            display: flex;
            flex-direction: column;
            height: 100vh;
            overflow-y: auto;
            /* Scroll vertical del contenedor principal */
        }

        .card-header {
            color: black;
            padding: 10px;
            font-size: 1.2em;
            text-align: center;
        }

        .scrollable-table {
            width: 100%;
            overflow-x: auto;
            border: 1px solid #ccc;
            margin: 10px 0;
        }

        .scrollable-table-v {
            max-height: 200px;
            /* Define la altura máxima del contenedor */
            overflow: auto;
            /* Scroll horizontal y vertical */
            border: 1px solid #ccc;
            width: 100%;
        }

        thead th {
            position: sticky;
            /* Mantiene el encabezado visible al hacer scroll */
            top: 0;
            background-color: #f4f4f4;
            /* Fondo para diferenciar el encabezado */
            z-index: 1;
            /* Garantiza que el encabezado esté por encima de las filas */
        }

        table {
            border-collapse: collapse;
            width: 100%;
            /* La tabla ocupa todo el ancho disponible */
        }

        th,
        td {
            border: 1px solid #ccc;
            padding: 8px;
            text-align: center;
            white-space: nowrap;
            /* Evita que se quiebren las celdas */
        }

        th {
            background-color: #f4f4f4;
        }

        td[contenteditable] {
            background-color: #fff;
            /* Fondo blanco para destacar celdas editables */
            cursor: text;
            /* Cambia el cursor a "texto" */
        }

        td[contenteditable]:focus {
            outline: 2px solid #007BFF;
            /* Resalta la celda activa */
        }

        .refresh-icon {
            font-size: 20px;
            /* Tamaño del ícono */
            color: #00abb0;
            /* Color del ícono */
            cursor: pointer;
            /* Cambia el cursor al pasar sobre el ícono */
            margin-left: 8px;
            transition: transform 0.2s;
            /* Animación al pasar el mouse */
        }

        .refresh-icon:hover {
            transform: rotate(360deg);
            /* Rotación al pasar el mouse */
            color: #00abb0;
            /* Cambia el color */
        }
    </style>
</head>

<body>
    <div class="card">
        <div class="card-header" style="display: flex; align-items: center; justify-content: space-between;">
            <b>Actualización de Tasas</b>
            <mat-icon class="refresh-icon"
                (click)="traerTasas();traerTnm();traerSeg();traerComision();traerEstado();traerCobranza()"
                aria-label="Refrescar">refresh</mat-icon>
        </div>
        <div class="scrollable-table">
            <table>
                <thead>
                    <tr>
                        <th>Plazos</th>
                        <th *ngFor="let plazo of plazos">{{ plazo }}</th>
                        <th>Botones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th>Tasa Efectiva Anual</th>
                        <td *ngFor="let tn of tnm; let i = index; trackBy: trackByIndex" contenteditable="true"
                            (blur)="actualizarTasa($event, i)">
                            {{ tn }}%
                        </td>
                        <td> <button (click)="guardarTasa()" mat-button class="btn btn-primary btn-sm">Guardar</button>
                        </td>
                    </tr>
                    <tr>
                        <th>Seguro</th>
                        <td *ngFor="let se of seg; let i = index; trackBy: trackByIndex" contenteditable="true"
                            (blur)="actualizarSeguro($event, i)">
                            {{ se | currency:'USD':'symbol':'1.2-2' }}
                        </td>
                        <td> <button (click)="guardarSeguros()" mat-button
                                class="btn btn-primary btn-sm">Guardar</button></td>
                    </tr>
                    <tr>
                        <th>Comisión</th>
                        <td *ngFor="let se of comision; let i = index; trackBy: trackByIndex" contenteditable="true"
                            (blur)="actualizarComision($event, i)">
                            {{ se | currency:'USD':'symbol':'1.0-0' }}
                        </td>
                        <td> <button (click)="guardarComision()" mat-button
                                class="btn btn-primary btn-sm">Guardar</button></td>
                    </tr>
                    <tr>
                        <th>Estado</th>
                        <td *ngFor="let estado of estados; let i = index; trackBy: trackByIndex" contenteditable="true"
                            (blur)="actualizarEstado($event, i)">
                            {{ estado }}
                        </td>
                        <td> <button (click)="guardarEstados()" mat-button
                                class="btn btn-primary btn-sm">Guardar</button></td>

                    </tr>
                    <tr>
                        <th>Tasa Gasto de Cobranza</th>
                        <td *ngFor="let cobranza of cobranza; let i = index; trackBy: trackByIndex"
                            contenteditable="true" (blur)="actualizarCobranza($event, i)">
                            {{ cobranza }}%
                        </td>
                        <td> <button (click)="guardarCobranza()" mat-button
                                class="btn btn-primary btn-sm">Guardar</button></td>

                    </tr>
                </tbody>
            </table>
        </div>

        <form [formGroup]="tasaForm">
            <div class="card-header pb-3 pt-3">
                Simulacion de Crédito
            </div>
            <div class="card-body row">
                <mat-form-field appearance="fill" class="col-12 col-md-6">
                    <mat-label>Capital</mat-label>
                    <input type="number" formControlName="capital" matInput>
                </mat-form-field>
                <button (click)="onSubmit()" mat-button class="primary mb-3 mr-1">
                    Simular
                </button>
            </div>
        </form>

        <div class="scrollable-table-v">
            <table>
                <thead>
                    <tr>
                        <th>No. Cuotas</th>
                        <th>Intereses</th>
                        <th>Seguro</th>
                        <th>Valor Cuota</th>
                        <th>Valor Financiado</th>
                        <th>Valor Full</th>
                        <th>Tasa</th>
                        <th>Seguro</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let index of cuotas; let i = index">
                        <td>{{ cuotas[i] }}</td>
                        <td>{{ intereses[i] | currency:'USD':'symbol':'1.0-0' }}</td>
                        <td>{{ seguro[i] | currency:'USD':'symbol':'1.0-0' }}</td>
                        <td>{{ cuota[i] | currency:'USD':'symbol':'1.0-0' }}</td>
                        <td>{{ financiado[i] | currency:'USD':'symbol':'1.0-0' }}</td>
                        <td>{{ full[i] | currency:'USD':'symbol':'1.0-0' }}</td>
                        <td>{{ tasas[i] }}%</td>
                        <td>{{ seguros[i] | currency:'USD':'symbol':'1.0-0' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</body>

</html>